export const Leagues = {
    "get": "fixtures",
    "parameters": {
        "league": "39",
        "season": "2022"
    },
    "errors": [],
    "results": 380,
    "paging": {
        "current": 1,
        "total": 1
    },
    "response": [
        {
            "fixture": {
                "id": 867946,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-08-05T19:00:00+00:00",
                "timestamp": 1659726000,
                "periods": {
                    "first": 1659726000,
                    "second": 1659729600
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867947,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-08-06T11:30:00+00:00",
                "timestamp": 1659785400,
                "periods": {
                    "first": 1659785400,
                    "second": 1659789000
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": null
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867948,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2022-08-06T14:00:00+00:00",
                "timestamp": 1659794400,
                "periods": {
                    "first": 1659794400,
                    "second": 1659798000
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867949,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-08-06T14:00:00+00:00",
                "timestamp": 1659794400,
                "periods": {
                    "first": 1659794400,
                    "second": 1659798000
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867950,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-08-07T13:00:00+00:00",
                "timestamp": 1659877200,
                "periods": {
                    "first": 1659877200,
                    "second": 1659880800
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867951,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-08-06T14:00:00+00:00",
                "timestamp": 1659794400,
                "periods": {
                    "first": 1659794400,
                    "second": 1659798000
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867952,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2022-08-06T14:00:00+00:00",
                "timestamp": 1659794400,
                "periods": {
                    "first": 1659794400,
                    "second": 1659798000
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867953,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-08-06T16:30:00+00:00",
                "timestamp": 1659803400,
                "periods": {
                    "first": 1659803400,
                    "second": 1659807000
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867954,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-08-07T13:00:00+00:00",
                "timestamp": 1659877200,
                "periods": {
                    "first": 1659877200,
                    "second": 1659880800
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867955,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-08-07T15:30:00+00:00",
                "timestamp": 1659886200,
                "periods": {
                    "first": 1659886200,
                    "second": 1659889800
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 1"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867956,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2022-08-13T14:00:00+00:00",
                "timestamp": 1660399200,
                "periods": {
                    "first": 1660399200,
                    "second": 1660402800
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867957,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-08-13T11:30:00+00:00",
                "timestamp": 1660390200,
                "periods": {
                    "first": 1660390200,
                    "second": 1660393800
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867958,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-08-13T16:30:00+00:00",
                "timestamp": 1660408200,
                "periods": {
                    "first": 1660408200,
                    "second": 1660411800
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 4,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867959,
                "referee": "Graham Scott, England",
                "timezone": "UTC",
                "date": "2022-08-13T14:00:00+00:00",
                "timestamp": 1660399200,
                "periods": {
                    "first": 1660399200,
                    "second": 1660402800
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867960,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-08-14T15:30:00+00:00",
                "timestamp": 1660491000,
                "periods": {
                    "first": 1660491000,
                    "second": 1660494600
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": null
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867961,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-08-15T19:00:00+00:00",
                "timestamp": 1660590000,
                "periods": {
                    "first": 1660590000,
                    "second": 1660593600
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-1.api-sports.io/football/teams/40.png",
                    "winner": null
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867962,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-08-13T14:00:00+00:00",
                "timestamp": 1660399200,
                "periods": {
                    "first": 1660399200,
                    "second": 1660402800
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867963,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-08-14T13:00:00+00:00",
                "timestamp": 1660482000,
                "periods": {
                    "first": 1660482000,
                    "second": 1660485600
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867964,
                "referee": "Tony Harrington, England",
                "timezone": "UTC",
                "date": "2022-08-13T14:00:00+00:00",
                "timestamp": 1660399200,
                "periods": {
                    "first": 1660399200,
                    "second": 1660402800
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": null
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867965,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2022-08-13T14:00:00+00:00",
                "timestamp": 1660399200,
                "periods": {
                    "first": 1660399200,
                    "second": 1660402800
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 2"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": null
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867966,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-08-20T16:30:00+00:00",
                "timestamp": 1661013000,
                "periods": {
                    "first": 1661013000,
                    "second": 1661016600
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867967,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-08-20T14:00:00+00:00",
                "timestamp": 1661004000,
                "periods": {
                    "first": 1661004000,
                    "second": 1661007600
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867968,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2022-08-20T14:00:00+00:00",
                "timestamp": 1661004000,
                "periods": {
                    "first": 1661004000,
                    "second": 1661007600
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": null
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867969,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2022-08-20T14:00:00+00:00",
                "timestamp": 1661004000,
                "periods": {
                    "first": 1661004000,
                    "second": 1661007600
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867970,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-08-21T13:00:00+00:00",
                "timestamp": 1661086800,
                "periods": {
                    "first": 1661086800,
                    "second": 1661090400
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867971,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2022-08-20T14:00:00+00:00",
                "timestamp": 1661004000,
                "periods": {
                    "first": 1661004000,
                    "second": 1661007600
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867972,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-08-22T19:00:00+00:00",
                "timestamp": 1661194800,
                "periods": {
                    "first": 1661194800,
                    "second": 1661198400
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867973,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-08-21T15:30:00+00:00",
                "timestamp": 1661095800,
                "periods": {
                    "first": 1661095800,
                    "second": 1661099400
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": null
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 3,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867974,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-08-20T11:30:00+00:00",
                "timestamp": 1660995000,
                "periods": {
                    "first": 1660995000,
                    "second": 1660998600
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867975,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-08-21T13:00:00+00:00",
                "timestamp": 1661086800,
                "periods": {
                    "first": 1661086800,
                    "second": 1661090400
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 3"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867976,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-08-27T16:30:00+00:00",
                "timestamp": 1661617800,
                "periods": {
                    "first": 1661617800,
                    "second": 1661621400
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867977,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-08-28T13:00:00+00:00",
                "timestamp": 1661691600,
                "periods": {
                    "first": 1661691600,
                    "second": 1661695200
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": false
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867978,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2022-08-27T14:00:00+00:00",
                "timestamp": 1661608800,
                "periods": {
                    "first": 1661608800,
                    "second": 1661612400
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867979,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2022-08-27T14:00:00+00:00",
                "timestamp": 1661608800,
                "periods": {
                    "first": 1661608800,
                    "second": 1661612400
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867980,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-08-27T14:00:00+00:00",
                "timestamp": 1661608800,
                "periods": {
                    "first": 1661608800,
                    "second": 1661612400
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867981,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-08-27T14:00:00+00:00",
                "timestamp": 1661608800,
                "periods": {
                    "first": 1661608800,
                    "second": 1661612400
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 9,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 5,
                    "away": 0
                },
                "fulltime": {
                    "home": 9,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867982,
                "referee": "Graham Scott, England",
                "timezone": "UTC",
                "date": "2022-08-27T14:00:00+00:00",
                "timestamp": 1661608800,
                "periods": {
                    "first": 1661608800,
                    "second": 1661612400
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 4,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867983,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-08-28T15:30:00+00:00",
                "timestamp": 1661700600,
                "periods": {
                    "first": 1661700600,
                    "second": 1661704200
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": false
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867984,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-08-27T11:30:00+00:00",
                "timestamp": 1661599800,
                "periods": {
                    "first": 1661599800,
                    "second": 1661603400
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867985,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2022-08-28T13:00:00+00:00",
                "timestamp": 1661691600,
                "periods": {
                    "first": 1661691600,
                    "second": 1661695200
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 4"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867986,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-08-31T18:30:00+00:00",
                "timestamp": 1661970600,
                "periods": {
                    "first": 1661970600,
                    "second": 1661974200
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": null
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867987,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-08-31T18:30:00+00:00",
                "timestamp": 1661970600,
                "periods": {
                    "first": 1661970600,
                    "second": 1661974200
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867988,
                "referee": "Thomas Bramall, England",
                "timezone": "UTC",
                "date": "2022-08-30T18:30:00+00:00",
                "timestamp": 1661884200,
                "periods": {
                    "first": 1661884200,
                    "second": 1661887800
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867989,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-08-30T19:00:00+00:00",
                "timestamp": 1661886000,
                "periods": {
                    "first": 1661886000,
                    "second": 1661889600
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867990,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-09-01T19:00:00+00:00",
                "timestamp": 1662058800,
                "periods": {
                    "first": 1662058800,
                    "second": 1662062400
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867991,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2022-08-31T18:45:00+00:00",
                "timestamp": 1661971500,
                "periods": {
                    "first": 1661971500,
                    "second": 1661975100
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": null
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867992,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2022-08-30T18:30:00+00:00",
                "timestamp": 1661884200,
                "periods": {
                    "first": 1661884200,
                    "second": 1661887800
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867993,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-08-30T18:45:00+00:00",
                "timestamp": 1661885100,
                "periods": {
                    "first": 1661885100,
                    "second": 1661888700
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867994,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2022-08-31T19:00:00+00:00",
                "timestamp": 1661972400,
                "periods": {
                    "first": 1661972400,
                    "second": 1661976000
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867995,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-08-31T18:30:00+00:00",
                "timestamp": 1661970600,
                "periods": {
                    "first": 1661970600,
                    "second": 1661974200
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 5"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 6,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 6,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867996,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-09-03T16:30:00+00:00",
                "timestamp": 1662222600,
                "periods": {
                    "first": 1662222600,
                    "second": 1662226200
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": null
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867997,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-09-03T14:00:00+00:00",
                "timestamp": 1662213600,
                "periods": {
                    "first": 1662213600,
                    "second": 1662217200
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 5,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867998,
                "referee": "Tony Harrington, England",
                "timezone": "UTC",
                "date": "2022-09-04T13:00:00+00:00",
                "timestamp": 1662296400,
                "periods": {
                    "first": 1662296400,
                    "second": 1662300000
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 2
                },
                "fulltime": {
                    "home": 5,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 867999,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-09-03T14:00:00+00:00",
                "timestamp": 1662213600,
                "periods": {
                    "first": 1662213600,
                    "second": 1662217200
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868000,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-09-03T11:30:00+00:00",
                "timestamp": 1662204600,
                "periods": {
                    "first": 1662204600,
                    "second": 1662208200
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": null
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-1.api-sports.io/football/teams/40.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868001,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-09-04T15:30:00+00:00",
                "timestamp": 1662305400,
                "periods": {
                    "first": 1662305400,
                    "second": 1662309000
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868002,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2022-09-03T14:00:00+00:00",
                "timestamp": 1662213600,
                "periods": {
                    "first": 1662213600,
                    "second": 1662217200
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": null
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868003,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-09-03T14:00:00+00:00",
                "timestamp": 1662213600,
                "periods": {
                    "first": 1662213600,
                    "second": 1662217200
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868004,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-09-03T14:00:00+00:00",
                "timestamp": 1662213600,
                "periods": {
                    "first": 1662213600,
                    "second": 1662217200
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868005,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2022-09-03T14:00:00+00:00",
                "timestamp": 1662213600,
                "periods": {
                    "first": 1662213600,
                    "second": 1662217200
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 6"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868006,
                "referee": "Darren Bond, England",
                "timezone": "UTC",
                "date": "2023-04-04T18:45:00+00:00",
                "timestamp": 1680633900,
                "periods": {
                    "first": 1680633900,
                    "second": 1680637500
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868007,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-03-01T19:45:00+00:00",
                "timestamp": 1677699900,
                "periods": {
                    "first": 1677699900,
                    "second": 1677703500
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868008,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-01-18T20:00:00+00:00",
                "timestamp": 1674072000,
                "periods": {
                    "first": 1674072000,
                    "second": 1674075600
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": null
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868009,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-01-12T20:00:00+00:00",
                "timestamp": 1673553600,
                "periods": {
                    "first": 1673553600,
                    "second": 1673557200
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868010,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-04-04T18:45:00+00:00",
                "timestamp": 1680633900,
                "periods": {
                    "first": 1680633900,
                    "second": 1680637500
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868011,
                "referee": "Graham Scott, England",
                "timezone": "UTC",
                "date": "2023-04-04T18:45:00+00:00",
                "timestamp": 1680633900,
                "periods": {
                    "first": 1680633900,
                    "second": 1680637500
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868012,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-03-01T20:00:00+00:00",
                "timestamp": 1677700800,
                "periods": {
                    "first": 1677700800,
                    "second": 1677704400
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868013,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-01-19T20:00:00+00:00",
                "timestamp": 1674158400,
                "periods": {
                    "first": 1674158400,
                    "second": 1674162000
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 4,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868014,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-03-15T19:30:00+00:00",
                "timestamp": 1678908600,
                "periods": {
                    "first": 1678908600,
                    "second": 1678912200
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868015,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-04-05T19:00:00+00:00",
                "timestamp": 1680721200,
                "periods": {
                    "first": 1680721200,
                    "second": 1680724800
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 7"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 5
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 5
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868016,
                "referee": "Tony Harrington, England",
                "timezone": "UTC",
                "date": "2022-09-16T19:00:00+00:00",
                "timestamp": 1663354800,
                "periods": {
                    "first": 1663354800,
                    "second": 1663358400
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868017,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-09-18T11:00:00+00:00",
                "timestamp": 1663498800,
                "periods": {
                    "first": 1663498800,
                    "second": 1663502400
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868018,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-03-15T19:30:00+00:00",
                "timestamp": 1678908600,
                "periods": {
                    "first": 1678908600,
                    "second": 1678912200
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868019,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-04-04T19:00:00+00:00",
                "timestamp": 1680634800,
                "periods": {
                    "first": 1680634800,
                    "second": 1680638400
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": null
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868020,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-09-18T13:15:00+00:00",
                "timestamp": 1663506900,
                "periods": {
                    "first": 1663506900,
                    "second": 1663510500
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868021,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-02-08T20:00:00+00:00",
                "timestamp": 1675886400,
                "periods": {
                    "first": 1675886400,
                    "second": 1675890000
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": null
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868022,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-09-17T14:00:00+00:00",
                "timestamp": 1663423200,
                "periods": {
                    "first": 1663423200,
                    "second": 1663426800
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": null
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868023,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-09-16T19:00:00+00:00",
                "timestamp": 1663354800,
                "periods": {
                    "first": 1663354800,
                    "second": 1663358400
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": false
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868024,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-09-17T16:30:00+00:00",
                "timestamp": 1663432200,
                "periods": {
                    "first": 1663432200,
                    "second": 1663435800
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 6,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 2
                },
                "fulltime": {
                    "home": 6,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868025,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-09-17T11:30:00+00:00",
                "timestamp": 1663414200,
                "periods": {
                    "first": 1663414200,
                    "second": 1663417800
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 8"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868026,
                "referee": "Thomas Bramall, England",
                "timezone": "UTC",
                "date": "2022-10-01T14:00:00+00:00",
                "timestamp": 1664632800,
                "periods": {
                    "first": 1664632800,
                    "second": 1664636400
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868027,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-10-01T11:30:00+00:00",
                "timestamp": 1664623800,
                "periods": {
                    "first": 1664623800,
                    "second": 1664627400
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868028,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2022-10-01T14:00:00+00:00",
                "timestamp": 1664632800,
                "periods": {
                    "first": 1664632800,
                    "second": 1664636400
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": false
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868029,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2022-10-01T14:00:00+00:00",
                "timestamp": 1664632800,
                "periods": {
                    "first": 1664632800,
                    "second": 1664636400
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 3
                },
                "fulltime": {
                    "home": 1,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868030,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-10-02T15:30:00+00:00",
                "timestamp": 1664724600,
                "periods": {
                    "first": 1664724600,
                    "second": 1664728200
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868031,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-10-03T19:00:00+00:00",
                "timestamp": 1664823600,
                "periods": {
                    "first": 1664823600,
                    "second": 1664827200
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868032,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-10-01T14:00:00+00:00",
                "timestamp": 1664632800,
                "periods": {
                    "first": 1664632800,
                    "second": 1664636400
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": null
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 3,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 3,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868033,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-10-02T13:00:00+00:00",
                "timestamp": 1664715600,
                "periods": {
                    "first": 1664715600,
                    "second": 1664719200
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 6,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 4,
                    "away": 0
                },
                "fulltime": {
                    "home": 6,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868034,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2022-10-01T14:00:00+00:00",
                "timestamp": 1664632800,
                "periods": {
                    "first": 1664632800,
                    "second": 1664636400
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868035,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-10-01T16:30:00+00:00",
                "timestamp": 1664641800,
                "periods": {
                    "first": 1664641800,
                    "second": 1664645400
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 9"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868036,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2022-10-08T14:00:00+00:00",
                "timestamp": 1665237600,
                "periods": {
                    "first": 1665237600,
                    "second": 1665241200
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868037,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-10-09T15:30:00+00:00",
                "timestamp": 1665329400,
                "periods": {
                    "first": 1665329400,
                    "second": 1665333000
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868038,
                "referee": "Tony Harrington, England",
                "timezone": "UTC",
                "date": "2022-10-08T16:30:00+00:00",
                "timestamp": 1665246600,
                "periods": {
                    "first": 1665246600,
                    "second": 1665250200
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": false
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868039,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-10-08T14:00:00+00:00",
                "timestamp": 1665237600,
                "periods": {
                    "first": 1665237600,
                    "second": 1665241200
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868040,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-10-09T13:00:00+00:00",
                "timestamp": 1665320400,
                "periods": {
                    "first": 1665320400,
                    "second": 1665324000
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868041,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-10-09T18:00:00+00:00",
                "timestamp": 1665338400,
                "periods": {
                    "first": 1665338400,
                    "second": 1665342000
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868042,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-10-08T14:00:00+00:00",
                "timestamp": 1665237600,
                "periods": {
                    "first": 1665237600,
                    "second": 1665241200
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868043,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2022-10-08T14:00:00+00:00",
                "timestamp": 1665237600,
                "periods": {
                    "first": 1665237600,
                    "second": 1665241200
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 5,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868044,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-10-10T19:00:00+00:00",
                "timestamp": 1665428400,
                "periods": {
                    "first": 1665428400,
                    "second": 1665432000
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": null
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868045,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2022-10-09T13:00:00+00:00",
                "timestamp": 1665320400,
                "periods": {
                    "first": 1665320400,
                    "second": 1665324000
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 10"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868046,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-10-16T13:00:00+00:00",
                "timestamp": 1665925200,
                "periods": {
                    "first": 1665925200,
                    "second": 1665928800
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": false
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868047,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2022-10-14T19:00:00+00:00",
                "timestamp": 1665774000,
                "periods": {
                    "first": 1665774000,
                    "second": 1665777600
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868048,
                "referee": "Graham Scott, England",
                "timezone": "UTC",
                "date": "2022-10-15T14:00:00+00:00",
                "timestamp": 1665842400,
                "periods": {
                    "first": 1665842400,
                    "second": 1665846000
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": null
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868049,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2022-10-16T13:00:00+00:00",
                "timestamp": 1665925200,
                "periods": {
                    "first": 1665925200,
                    "second": 1665928800
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868050,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-10-15T11:30:00+00:00",
                "timestamp": 1665833400,
                "periods": {
                    "first": 1665833400,
                    "second": 1665837000
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": null
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868051,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-10-16T15:30:00+00:00",
                "timestamp": 1665934200,
                "periods": {
                    "first": 1665934200,
                    "second": 1665937800
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868052,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-10-16T13:00:00+00:00",
                "timestamp": 1665925200,
                "periods": {
                    "first": 1665925200,
                    "second": 1665928800
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868053,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2022-10-16T13:00:00+00:00",
                "timestamp": 1665925200,
                "periods": {
                    "first": 1665925200,
                    "second": 1665928800
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": null
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868054,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-10-15T16:30:00+00:00",
                "timestamp": 1665851400,
                "periods": {
                    "first": 1665851400,
                    "second": 1665855000
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868055,
                "referee": "Thomas Bramall, England",
                "timezone": "UTC",
                "date": "2022-10-15T14:00:00+00:00",
                "timestamp": 1665842400,
                "periods": {
                    "first": 1665842400,
                    "second": 1665846000
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 11"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868056,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2022-10-19T18:30:00+00:00",
                "timestamp": 1666204200,
                "periods": {
                    "first": 1666204200,
                    "second": 1666207800
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868057,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-02-15T19:30:00+00:00",
                "timestamp": 1676489400,
                "periods": {
                    "first": 1676489400,
                    "second": 1676493000
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868058,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-10-19T18:30:00+00:00",
                "timestamp": 1666204200,
                "periods": {
                    "first": 1666204200,
                    "second": 1666207800
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868059,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2022-10-18T18:30:00+00:00",
                "timestamp": 1666117800,
                "periods": {
                    "first": 1666117800,
                    "second": 1666121400
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": null
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868060,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-10-20T18:30:00+00:00",
                "timestamp": 1666290600,
                "periods": {
                    "first": 1666290600,
                    "second": 1666294200
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868061,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2022-10-20T19:15:00+00:00",
                "timestamp": 1666293300,
                "periods": {
                    "first": 1666293300,
                    "second": 1666296900
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868062,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-10-18T19:15:00+00:00",
                "timestamp": 1666120500,
                "periods": {
                    "first": 1666120500,
                    "second": 1666124100
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868063,
                "referee": "Tony Harrington, England",
                "timezone": "UTC",
                "date": "2022-10-19T18:30:00+00:00",
                "timestamp": 1666204200,
                "periods": {
                    "first": 1666204200,
                    "second": 1666207800
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868064,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-10-19T18:30:00+00:00",
                "timestamp": 1666204200,
                "periods": {
                    "first": 1666204200,
                    "second": 1666207800
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-1.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868065,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-10-19T19:15:00+00:00",
                "timestamp": 1666206900,
                "periods": {
                    "first": 1666206900,
                    "second": 1666210500
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 12"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868066,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2022-10-23T13:00:00+00:00",
                "timestamp": 1666530000,
                "periods": {
                    "first": 1666530000,
                    "second": 1666533600
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868067,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-10-22T16:30:00+00:00",
                "timestamp": 1666456200,
                "periods": {
                    "first": 1666456200,
                    "second": 1666459800
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": null
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868068,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-10-22T14:00:00+00:00",
                "timestamp": 1666447200,
                "periods": {
                    "first": 1666447200,
                    "second": 1666450800
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868069,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-10-23T13:00:00+00:00",
                "timestamp": 1666530000,
                "periods": {
                    "first": 1666530000,
                    "second": 1666533600
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": false
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868070,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-10-22T14:00:00+00:00",
                "timestamp": 1666447200,
                "periods": {
                    "first": 1666447200,
                    "second": 1666450800
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868071,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-10-22T11:30:00+00:00",
                "timestamp": 1666438200,
                "periods": {
                    "first": 1666438200,
                    "second": 1666441800
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868072,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-10-23T13:00:00+00:00",
                "timestamp": 1666530000,
                "periods": {
                    "first": 1666530000,
                    "second": 1666533600
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": null
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868073,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-10-23T15:30:00+00:00",
                "timestamp": 1666539000,
                "periods": {
                    "first": 1666539000,
                    "second": 1666542600
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868074,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-10-24T19:00:00+00:00",
                "timestamp": 1666638000,
                "periods": {
                    "first": 1666638000,
                    "second": 1666641600
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868075,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-10-23T13:00:00+00:00",
                "timestamp": 1666530000,
                "periods": {
                    "first": 1666530000,
                    "second": 1666533600
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 13"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": false
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868076,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-10-29T14:00:00+00:00",
                "timestamp": 1667052000,
                "periods": {
                    "first": 1667052000,
                    "second": 1667055600
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868077,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-10-30T14:00:00+00:00",
                "timestamp": 1667138400,
                "periods": {
                    "first": 1667138400,
                    "second": 1667142000
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 5,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868078,
                "referee": "Robert Madley, England",
                "timezone": "UTC",
                "date": "2022-10-29T14:00:00+00:00",
                "timestamp": 1667052000,
                "periods": {
                    "first": 1667052000,
                    "second": 1667055600
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868079,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-10-29T14:00:00+00:00",
                "timestamp": 1667052000,
                "periods": {
                    "first": 1667052000,
                    "second": 1667055600
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868080,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2022-10-29T14:00:00+00:00",
                "timestamp": 1667052000,
                "periods": {
                    "first": 1667052000,
                    "second": 1667055600
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868081,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2022-10-29T16:30:00+00:00",
                "timestamp": 1667061000,
                "periods": {
                    "first": 1667061000,
                    "second": 1667064600
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868082,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-10-29T11:30:00+00:00",
                "timestamp": 1667043000,
                "periods": {
                    "first": 1667043000,
                    "second": 1667046600
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868083,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-10-29T18:45:00+00:00",
                "timestamp": 1667069100,
                "periods": {
                    "first": 1667069100,
                    "second": 1667072700
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": false
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868084,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2022-10-30T16:15:00+00:00",
                "timestamp": 1667146500,
                "periods": {
                    "first": 1667146500,
                    "second": 1667150100
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868085,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-10-29T14:00:00+00:00",
                "timestamp": 1667052000,
                "periods": {
                    "first": 1667052000,
                    "second": 1667055600
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 14"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868086,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-11-06T14:00:00+00:00",
                "timestamp": 1667743200,
                "periods": {
                    "first": 1667743200,
                    "second": 1667746800
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868087,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-11-06T12:00:00+00:00",
                "timestamp": 1667736000,
                "periods": {
                    "first": 1667736000,
                    "second": 1667739600
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868088,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-11-05T17:30:00+00:00",
                "timestamp": 1667669400,
                "periods": {
                    "first": 1667669400,
                    "second": 1667673000
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868089,
                "referee": "Tony Harrington, England",
                "timezone": "UTC",
                "date": "2022-11-05T15:00:00+00:00",
                "timestamp": 1667660400,
                "periods": {
                    "first": 1667660400,
                    "second": 1667664000
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 4,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868090,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2022-11-05T15:00:00+00:00",
                "timestamp": 1667660400,
                "periods": {
                    "first": 1667660400,
                    "second": 1667664000
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868091,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2022-11-05T15:00:00+00:00",
                "timestamp": 1667660400,
                "periods": {
                    "first": 1667660400,
                    "second": 1667664000
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868092,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-11-06T14:00:00+00:00",
                "timestamp": 1667743200,
                "periods": {
                    "first": 1667743200,
                    "second": 1667746800
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868093,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-11-06T16:30:00+00:00",
                "timestamp": 1667752200,
                "periods": {
                    "first": 1667752200,
                    "second": 1667755800
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": false
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868094,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-11-06T14:00:00+00:00",
                "timestamp": 1667743200,
                "periods": {
                    "first": 1667743200,
                    "second": 1667746800
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": false
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868095,
                "referee": "Graham Scott, England",
                "timezone": "UTC",
                "date": "2022-11-05T15:00:00+00:00",
                "timestamp": 1667660400,
                "periods": {
                    "first": 1667660400,
                    "second": 1667664000
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 15"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 2
                },
                "fulltime": {
                    "home": 2,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868096,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-11-12T15:00:00+00:00",
                "timestamp": 1668265200,
                "periods": {
                    "first": 1668265200,
                    "second": 1668268800
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868097,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2022-11-13T14:00:00+00:00",
                "timestamp": 1668348000,
                "periods": {
                    "first": 1668348000,
                    "second": 1668351600
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": false
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868098,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-11-13T16:30:00+00:00",
                "timestamp": 1668357000,
                "periods": {
                    "first": 1668357000,
                    "second": 1668360600
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": false
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868099,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-11-12T15:00:00+00:00",
                "timestamp": 1668265200,
                "periods": {
                    "first": 1668265200,
                    "second": 1668268800
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868100,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2022-11-12T12:30:00+00:00",
                "timestamp": 1668256200,
                "periods": {
                    "first": 1668256200,
                    "second": 1668259800
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": false
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868101,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-11-12T17:30:00+00:00",
                "timestamp": 1668274200,
                "periods": {
                    "first": 1668274200,
                    "second": 1668277800
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868102,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2022-11-12T15:00:00+00:00",
                "timestamp": 1668265200,
                "periods": {
                    "first": 1668265200,
                    "second": 1668268800
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868103,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2022-11-12T15:00:00+00:00",
                "timestamp": 1668265200,
                "periods": {
                    "first": 1668265200,
                    "second": 1668268800
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 4,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868104,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-11-12T15:00:00+00:00",
                "timestamp": 1668265200,
                "periods": {
                    "first": 1668265200,
                    "second": 1668268800
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868105,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-11-12T19:45:00+00:00",
                "timestamp": 1668282300,
                "periods": {
                    "first": 1668282300,
                    "second": 1668285900
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 16"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868106,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2022-12-26T20:00:00+00:00",
                "timestamp": 1672084800,
                "periods": {
                    "first": 1672084800,
                    "second": 1672088400
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868107,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2022-12-26T17:30:00+00:00",
                "timestamp": 1672075800,
                "periods": {
                    "first": 1672075800,
                    "second": 1672079400
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": false
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868108,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2022-12-26T12:30:00+00:00",
                "timestamp": 1672057800,
                "periods": {
                    "first": 1672057800,
                    "second": 1672061400
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868109,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-12-27T17:30:00+00:00",
                "timestamp": 1672162200,
                "periods": {
                    "first": 1672162200,
                    "second": 1672165800
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868110,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-12-26T15:00:00+00:00",
                "timestamp": 1672066800,
                "periods": {
                    "first": 1672066800,
                    "second": 1672070400
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": false
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868111,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-12-26T15:00:00+00:00",
                "timestamp": 1672066800,
                "periods": {
                    "first": 1672066800,
                    "second": 1672070400
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868112,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2022-12-28T20:00:00+00:00",
                "timestamp": 1672257600,
                "periods": {
                    "first": 1672257600,
                    "second": 1672261200
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868113,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2022-12-26T15:00:00+00:00",
                "timestamp": 1672066800,
                "periods": {
                    "first": 1672066800,
                    "second": 1672070400
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 3
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868114,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-12-27T20:00:00+00:00",
                "timestamp": 1672171200,
                "periods": {
                    "first": 1672171200,
                    "second": 1672174800
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868115,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-12-26T15:00:00+00:00",
                "timestamp": 1672066800,
                "periods": {
                    "first": 1672066800,
                    "second": 1672070400
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 17"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868116,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2022-12-31T15:00:00+00:00",
                "timestamp": 1672498800,
                "periods": {
                    "first": 1672498800,
                    "second": 1672502400
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868117,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2022-12-31T17:30:00+00:00",
                "timestamp": 1672507800,
                "periods": {
                    "first": 1672507800,
                    "second": 1672511400
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 2,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868118,
                "referee": "Graham Scott, England",
                "timezone": "UTC",
                "date": "2022-12-31T15:00:00+00:00",
                "timestamp": 1672498800,
                "periods": {
                    "first": 1672498800,
                    "second": 1672502400
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868119,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2022-12-30T20:00:00+00:00",
                "timestamp": 1672430400,
                "periods": {
                    "first": 1672430400,
                    "second": 1672434000
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868120,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2022-12-31T15:00:00+00:00",
                "timestamp": 1672498800,
                "periods": {
                    "first": 1672498800,
                    "second": 1672502400
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868121,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2022-12-31T15:00:00+00:00",
                "timestamp": 1672498800,
                "periods": {
                    "first": 1672498800,
                    "second": 1672502400
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": null
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868122,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-01-01T16:30:00+00:00",
                "timestamp": 1672590600,
                "periods": {
                    "first": 1672590600,
                    "second": 1672594200
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": null
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868123,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-01-01T14:00:00+00:00",
                "timestamp": 1672581600,
                "periods": {
                    "first": 1672581600,
                    "second": 1672585200
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": false
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868124,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2022-12-30T19:45:00+00:00",
                "timestamp": 1672429500,
                "periods": {
                    "first": 1672429500,
                    "second": 1672433100
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868125,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2022-12-31T12:30:00+00:00",
                "timestamp": 1672489800,
                "periods": {
                    "first": 1672489800,
                    "second": 1672493400
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 18"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868126,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-01-03T19:45:00+00:00",
                "timestamp": 1672775100,
                "periods": {
                    "first": 1672775100,
                    "second": 1672778700
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868127,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2023-01-04T20:00:00+00:00",
                "timestamp": 1672862400,
                "periods": {
                    "first": 1672862400,
                    "second": 1672866000
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": null
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868128,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-01-02T17:30:00+00:00",
                "timestamp": 1672680600,
                "periods": {
                    "first": 1672680600,
                    "second": 1672684200
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868129,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-01-05T20:00:00+00:00",
                "timestamp": 1672948800,
                "periods": {
                    "first": 1672948800,
                    "second": 1672952400
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868130,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-01-04T20:00:00+00:00",
                "timestamp": 1672862400,
                "periods": {
                    "first": 1672862400,
                    "second": 1672866000
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": false
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868131,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2023-01-03T19:45:00+00:00",
                "timestamp": 1672775100,
                "periods": {
                    "first": 1672775100,
                    "second": 1672778700
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868132,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-01-04T19:45:00+00:00",
                "timestamp": 1672861500,
                "periods": {
                    "first": 1672861500,
                    "second": 1672865100
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868133,
                "referee": "Darren Bond, England",
                "timezone": "UTC",
                "date": "2023-01-03T19:45:00+00:00",
                "timestamp": 1672775100,
                "periods": {
                    "first": 1672775100,
                    "second": 1672778700
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868134,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-01-03T20:00:00+00:00",
                "timestamp": 1672776000,
                "periods": {
                    "first": 1672776000,
                    "second": 1672779600
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868135,
                "referee": "Thomas Bramall, England",
                "timezone": "UTC",
                "date": "2023-01-04T19:30:00+00:00",
                "timestamp": 1672860600,
                "periods": {
                    "first": 1672860600,
                    "second": 1672864200
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 19"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868136,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-01-13T20:00:00+00:00",
                "timestamp": 1673640000,
                "periods": {
                    "first": 1673640000,
                    "second": 1673643600
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868137,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2023-01-14T17:30:00+00:00",
                "timestamp": 1673717400,
                "periods": {
                    "first": 1673717400,
                    "second": 1673721000
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868138,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-01-14T15:00:00+00:00",
                "timestamp": 1673708400,
                "periods": {
                    "first": 1673708400,
                    "second": 1673712000
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868139,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-01-15T14:00:00+00:00",
                "timestamp": 1673791200,
                "periods": {
                    "first": 1673791200,
                    "second": 1673794800
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868140,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-01-14T15:00:00+00:00",
                "timestamp": 1673708400,
                "periods": {
                    "first": 1673708400,
                    "second": 1673712000
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868141,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-01-14T12:30:00+00:00",
                "timestamp": 1673699400,
                "periods": {
                    "first": 1673699400,
                    "second": 1673703000
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868142,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-01-15T14:00:00+00:00",
                "timestamp": 1673791200,
                "periods": {
                    "first": 1673791200,
                    "second": 1673794800
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868143,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-01-14T15:00:00+00:00",
                "timestamp": 1673708400,
                "periods": {
                    "first": 1673708400,
                    "second": 1673712000
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868144,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-01-15T16:30:00+00:00",
                "timestamp": 1673800200,
                "periods": {
                    "first": 1673800200,
                    "second": 1673803800
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868145,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-01-14T15:00:00+00:00",
                "timestamp": 1673708400,
                "periods": {
                    "first": 1673708400,
                    "second": 1673712000
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 20"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-3.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868146,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-01-21T15:00:00+00:00",
                "timestamp": 1674313200,
                "periods": {
                    "first": 1674313200,
                    "second": 1674316800
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": null
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868147,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-01-22T16:30:00+00:00",
                "timestamp": 1674405000,
                "periods": {
                    "first": 1674405000,
                    "second": 1674408600
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868148,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-01-21T17:30:00+00:00",
                "timestamp": 1674322200,
                "periods": {
                    "first": 1674322200,
                    "second": 1674325800
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868149,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-01-23T20:00:00+00:00",
                "timestamp": 1674504000,
                "periods": {
                    "first": 1674504000,
                    "second": 1674507600
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": false
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868150,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-01-22T14:00:00+00:00",
                "timestamp": 1674396000,
                "periods": {
                    "first": 1674396000,
                    "second": 1674399600
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868151,
                "referee": "Thomas Bramall, England",
                "timezone": "UTC",
                "date": "2023-01-21T15:00:00+00:00",
                "timestamp": 1674313200,
                "periods": {
                    "first": 1674313200,
                    "second": 1674316800
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": null
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868152,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-01-21T12:30:00+00:00",
                "timestamp": 1674304200,
                "periods": {
                    "first": 1674304200,
                    "second": 1674307800
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": null
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868153,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-01-22T14:00:00+00:00",
                "timestamp": 1674396000,
                "periods": {
                    "first": 1674396000,
                    "second": 1674399600
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868154,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-01-21T15:00:00+00:00",
                "timestamp": 1674313200,
                "periods": {
                    "first": 1674313200,
                    "second": 1674316800
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868155,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-01-21T15:00:00+00:00",
                "timestamp": 1674313200,
                "periods": {
                    "first": 1674313200,
                    "second": 1674316800
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 21"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868156,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-02-04T15:00:00+00:00",
                "timestamp": 1675522800,
                "periods": {
                    "first": 1675522800,
                    "second": 1675526400
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": false
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 3
                },
                "fulltime": {
                    "home": 2,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868157,
                "referee": "Darren Bond, England",
                "timezone": "UTC",
                "date": "2023-02-04T15:00:00+00:00",
                "timestamp": 1675522800,
                "periods": {
                    "first": 1675522800,
                    "second": 1675526400
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868158,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-02-04T15:00:00+00:00",
                "timestamp": 1675522800,
                "periods": {
                    "first": 1675522800,
                    "second": 1675526400
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868159,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-02-03T20:00:00+00:00",
                "timestamp": 1675454400,
                "periods": {
                    "first": 1675454400,
                    "second": 1675458000
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": null
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868160,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-02-04T12:30:00+00:00",
                "timestamp": 1675513800,
                "periods": {
                    "first": 1675513800,
                    "second": 1675517400
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": true
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868161,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2023-02-04T15:00:00+00:00",
                "timestamp": 1675522800,
                "periods": {
                    "first": 1675522800,
                    "second": 1675526400
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868162,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-02-04T17:30:00+00:00",
                "timestamp": 1675531800,
                "periods": {
                    "first": 1675531800,
                    "second": 1675535400
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": null
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868163,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-02-05T14:00:00+00:00",
                "timestamp": 1675605600,
                "periods": {
                    "first": 1675605600,
                    "second": 1675609200
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868164,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-02-05T16:30:00+00:00",
                "timestamp": 1675614600,
                "periods": {
                    "first": 1675614600,
                    "second": 1675618200
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868165,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-02-04T15:00:00+00:00",
                "timestamp": 1675522800,
                "periods": {
                    "first": 1675522800,
                    "second": 1675526400
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 22"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-1.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868166,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-02-11T17:30:00+00:00",
                "timestamp": 1676136600,
                "periods": {
                    "first": 1676136600,
                    "second": 1676140200
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868167,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-02-11T15:00:00+00:00",
                "timestamp": 1676127600,
                "periods": {
                    "first": 1676127600,
                    "second": 1676131200
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868168,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-02-11T15:00:00+00:00",
                "timestamp": 1676127600,
                "periods": {
                    "first": 1676127600,
                    "second": 1676131200
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": null
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868169,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-02-11T15:00:00+00:00",
                "timestamp": 1676127600,
                "periods": {
                    "first": 1676127600,
                    "second": 1676131200
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868170,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-02-12T14:00:00+00:00",
                "timestamp": 1676210400,
                "periods": {
                    "first": 1676210400,
                    "second": 1676214000
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": false
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868171,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-02-11T15:00:00+00:00",
                "timestamp": 1676127600,
                "periods": {
                    "first": 1676127600,
                    "second": 1676131200
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 1
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868172,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-02-13T20:00:00+00:00",
                "timestamp": 1676318400,
                "periods": {
                    "first": 1676318400,
                    "second": 1676322000
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868173,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-02-12T16:30:00+00:00",
                "timestamp": 1676219400,
                "periods": {
                    "first": 1676219400,
                    "second": 1676223000
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868174,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2023-02-11T15:00:00+00:00",
                "timestamp": 1676127600,
                "periods": {
                    "first": 1676127600,
                    "second": 1676131200
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868175,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-02-11T12:30:00+00:00",
                "timestamp": 1676118600,
                "periods": {
                    "first": 1676118600,
                    "second": 1676122200
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 23"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": null
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868176,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-02-18T12:30:00+00:00",
                "timestamp": 1676723400,
                "periods": {
                    "first": 1676723400,
                    "second": 1676727000
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868177,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-02-18T15:00:00+00:00",
                "timestamp": 1676732400,
                "periods": {
                    "first": 1676732400,
                    "second": 1676736000
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868178,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-02-18T15:00:00+00:00",
                "timestamp": 1676732400,
                "periods": {
                    "first": 1676732400,
                    "second": 1676736000
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": false
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868179,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-02-18T15:00:00+00:00",
                "timestamp": 1676732400,
                "periods": {
                    "first": 1676732400,
                    "second": 1676736000
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868180,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-02-18T15:00:00+00:00",
                "timestamp": 1676732400,
                "periods": {
                    "first": 1676732400,
                    "second": 1676736000
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868181,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-02-19T14:00:00+00:00",
                "timestamp": 1676815200,
                "periods": {
                    "first": 1676815200,
                    "second": 1676818800
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868182,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-02-18T17:30:00+00:00",
                "timestamp": 1676741400,
                "periods": {
                    "first": 1676741400,
                    "second": 1676745000
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": false
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868183,
                "referee": "Graham Scott, England",
                "timezone": "UTC",
                "date": "2023-02-18T15:00:00+00:00",
                "timestamp": 1676732400,
                "periods": {
                    "first": 1676732400,
                    "second": 1676736000
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": null
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868184,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-02-19T16:30:00+00:00",
                "timestamp": 1676824200,
                "periods": {
                    "first": 1676824200,
                    "second": 1676827800
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868185,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-02-18T15:00:00+00:00",
                "timestamp": 1676732400,
                "periods": {
                    "first": 1676732400,
                    "second": 1676736000
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 24"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": false
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868186,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-02-25T17:30:00+00:00",
                "timestamp": 1677346200,
                "periods": {
                    "first": 1677346200,
                    "second": 1677349800
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 3
                },
                "fulltime": {
                    "home": 1,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868187,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-02-25T19:45:00+00:00",
                "timestamp": 1677354300,
                "periods": {
                    "first": 1677354300,
                    "second": 1677357900
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": null
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868188,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-02-25T15:00:00+00:00",
                "timestamp": 1677337200,
                "periods": {
                    "first": 1677337200,
                    "second": 1677340800
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868189,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-02-24T20:00:00+00:00",
                "timestamp": 1677268800,
                "periods": {
                    "first": 1677268800,
                    "second": 1677272400
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": null
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868190,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-02-25T15:00:00+00:00",
                "timestamp": 1677337200,
                "periods": {
                    "first": 1677337200,
                    "second": 1677340800
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868191,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-02-25T15:00:00+00:00",
                "timestamp": 1677337200,
                "periods": {
                    "first": 1677337200,
                    "second": 1677340800
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868192,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-04-05T19:00:00+00:00",
                "timestamp": 1680721200,
                "periods": {
                    "first": 1680721200,
                    "second": 1680724800
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868193,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-05-18T18:30:00+00:00",
                "timestamp": 1684434600,
                "periods": {
                    "first": 1684434600,
                    "second": 1684438200
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868194,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-02-26T13:30:00+00:00",
                "timestamp": 1677418200,
                "periods": {
                    "first": 1677418200,
                    "second": 1677421800
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868195,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2023-02-25T15:00:00+00:00",
                "timestamp": 1677337200,
                "periods": {
                    "first": 1677337200,
                    "second": 1677340800
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 25"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868196,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2023-03-04T15:00:00+00:00",
                "timestamp": 1677942000,
                "periods": {
                    "first": 1677942000,
                    "second": 1677945600
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868197,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-03-04T15:00:00+00:00",
                "timestamp": 1677942000,
                "periods": {
                    "first": 1677942000,
                    "second": 1677945600
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868198,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-03-06T20:00:00+00:00",
                "timestamp": 1678132800,
                "periods": {
                    "first": 1678132800,
                    "second": 1678136400
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868199,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-03-04T15:00:00+00:00",
                "timestamp": 1677942000,
                "periods": {
                    "first": 1677942000,
                    "second": 1677945600
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868200,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-03-04T15:00:00+00:00",
                "timestamp": 1677942000,
                "periods": {
                    "first": 1677942000,
                    "second": 1677945600
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868201,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-03-05T16:30:00+00:00",
                "timestamp": 1678033800,
                "periods": {
                    "first": 1678033800,
                    "second": 1678037400
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 7,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 7,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868202,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-03-04T12:30:00+00:00",
                "timestamp": 1677933000,
                "periods": {
                    "first": 1677933000,
                    "second": 1677936600
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868203,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-03-05T14:00:00+00:00",
                "timestamp": 1678024800,
                "periods": {
                    "first": 1678024800,
                    "second": 1678028400
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868204,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-03-04T17:30:00+00:00",
                "timestamp": 1677951000,
                "periods": {
                    "first": 1677951000,
                    "second": 1677954600
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868205,
                "referee": "Tim Robinson, England",
                "timezone": "UTC",
                "date": "2023-03-04T15:00:00+00:00",
                "timestamp": 1677942000,
                "periods": {
                    "first": 1677942000,
                    "second": 1677945600
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 26"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868206,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-03-11T12:30:00+00:00",
                "timestamp": 1678537800,
                "periods": {
                    "first": 1678537800,
                    "second": 1678541400
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868207,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-03-11T17:30:00+00:00",
                "timestamp": 1678555800,
                "periods": {
                    "first": 1678555800,
                    "second": 1678559400
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868208,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-03-11T15:00:00+00:00",
                "timestamp": 1678546800,
                "periods": {
                    "first": 1678546800,
                    "second": 1678550400
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": true
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868209,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-03-12T14:00:00+00:00",
                "timestamp": 1678629600,
                "periods": {
                    "first": 1678629600,
                    "second": 1678633200
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 3
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868210,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-03-11T15:00:00+00:00",
                "timestamp": 1678546800,
                "periods": {
                    "first": 1678546800,
                    "second": 1678550400
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868211,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2023-03-11T15:00:00+00:00",
                "timestamp": 1678546800,
                "periods": {
                    "first": 1678546800,
                    "second": 1678550400
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868212,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-03-12T14:00:00+00:00",
                "timestamp": 1678629600,
                "periods": {
                    "first": 1678629600,
                    "second": 1678633200
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-2.api-sports.io/football/teams/33.png",
                    "winner": null
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868213,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-03-12T16:30:00+00:00",
                "timestamp": 1678638600,
                "periods": {
                    "first": 1678638600,
                    "second": 1678642200
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868214,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-03-11T15:00:00+00:00",
                "timestamp": 1678546800,
                "periods": {
                    "first": 1678546800,
                    "second": 1678550400
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-1.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868215,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2023-03-12T14:00:00+00:00",
                "timestamp": 1678629600,
                "periods": {
                    "first": 1678629600,
                    "second": 1678633200
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 27"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": null
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868216,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-03-19T14:00:00+00:00",
                "timestamp": 1679234400,
                "periods": {
                    "first": 1679234400,
                    "second": 1679238000
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868217,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-03-18T15:00:00+00:00",
                "timestamp": 1679151600,
                "periods": {
                    "first": 1679151600,
                    "second": 1679155200
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868218,
                "referee": "Darren Bond, England",
                "timezone": "UTC",
                "date": "2023-03-18T15:00:00+00:00",
                "timestamp": 1679151600,
                "periods": {
                    "first": 1679151600,
                    "second": 1679155200
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-1.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868219,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2023-05-04T19:00:00+00:00",
                "timestamp": 1683226800,
                "periods": {
                    "first": 1683226800,
                    "second": 1683230400
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868220,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-03-18T17:30:00+00:00",
                "timestamp": 1679160600,
                "periods": {
                    "first": 1679160600,
                    "second": 1679164200
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868221,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-05-03T19:00:00+00:00",
                "timestamp": 1683140400,
                "periods": {
                    "first": 1683140400,
                    "second": 1683144000
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868222,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-05-03T19:00:00+00:00",
                "timestamp": 1683140400,
                "periods": {
                    "first": 1683140400,
                    "second": 1683144000
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868223,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-03-17T20:00:00+00:00",
                "timestamp": 1679083200,
                "periods": {
                    "first": 1679083200,
                    "second": 1679086800
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868224,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-03-18T15:00:00+00:00",
                "timestamp": 1679151600,
                "periods": {
                    "first": 1679151600,
                    "second": 1679155200
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": null
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 3,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868225,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-03-18T15:00:00+00:00",
                "timestamp": 1679151600,
                "periods": {
                    "first": 1679151600,
                    "second": 1679155200
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 28"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868226,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-04-01T14:00:00+00:00",
                "timestamp": 1680357600,
                "periods": {
                    "first": 1680357600,
                    "second": 1680361200
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-2.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868227,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-04-01T14:00:00+00:00",
                "timestamp": 1680357600,
                "periods": {
                    "first": 1680357600,
                    "second": 1680361200
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868228,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-04-01T14:00:00+00:00",
                "timestamp": 1680357600,
                "periods": {
                    "first": 1680357600,
                    "second": 1680361200
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 3,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 2
                },
                "fulltime": {
                    "home": 3,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868229,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-04-01T16:30:00+00:00",
                "timestamp": 1680366600,
                "periods": {
                    "first": 1680366600,
                    "second": 1680370200
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-3.api-sports.io/football/teams/49.png",
                    "winner": false
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868230,
                "referee": "Tim Robinson, England",
                "timezone": "UTC",
                "date": "2023-04-01T14:00:00+00:00",
                "timestamp": 1680357600,
                "periods": {
                    "first": 1680357600,
                    "second": 1680361200
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868231,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-04-03T19:00:00+00:00",
                "timestamp": 1680548400,
                "periods": {
                    "first": 1680548400,
                    "second": 1680552000
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": null
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868232,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-04-01T11:30:00+00:00",
                "timestamp": 1680348600,
                "periods": {
                    "first": 1680348600,
                    "second": 1680352200
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-1.api-sports.io/football/teams/40.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868233,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-04-02T15:30:00+00:00",
                "timestamp": 1680449400,
                "periods": {
                    "first": 1680449400,
                    "second": 1680453000
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868234,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2023-04-01T14:00:00+00:00",
                "timestamp": 1680357600,
                "periods": {
                    "first": 1680357600,
                    "second": 1680361200
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": null
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868235,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-04-02T13:00:00+00:00",
                "timestamp": 1680440400,
                "periods": {
                    "first": 1680440400,
                    "second": 1680444000
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 29"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868236,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-04-08T14:00:00+00:00",
                "timestamp": 1680962400,
                "periods": {
                    "first": 1680962400,
                    "second": 1680966000
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868237,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2023-04-08T14:00:00+00:00",
                "timestamp": 1680962400,
                "periods": {
                    "first": 1680962400,
                    "second": 1680966000
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868238,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2023-04-08T14:00:00+00:00",
                "timestamp": 1680962400,
                "periods": {
                    "first": 1680962400,
                    "second": 1680966000
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": false
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868239,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-04-09T13:00:00+00:00",
                "timestamp": 1681045200,
                "periods": {
                    "first": 1681045200,
                    "second": 1681048800
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 5
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 5
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868240,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-04-08T14:00:00+00:00",
                "timestamp": 1680962400,
                "periods": {
                    "first": 1680962400,
                    "second": 1680966000
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868241,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-04-09T15:30:00+00:00",
                "timestamp": 1681054200,
                "periods": {
                    "first": 1681054200,
                    "second": 1681057800
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": null
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868242,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-04-08T11:30:00+00:00",
                "timestamp": 1680953400,
                "periods": {
                    "first": 1680953400,
                    "second": 1680957000
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868243,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-04-08T16:30:00+00:00",
                "timestamp": 1680971400,
                "periods": {
                    "first": 1680971400,
                    "second": 1680975000
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868244,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-04-08T14:00:00+00:00",
                "timestamp": 1680962400,
                "periods": {
                    "first": 1680962400,
                    "second": 1680966000
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868245,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-04-08T14:00:00+00:00",
                "timestamp": 1680962400,
                "periods": {
                    "first": 1680962400,
                    "second": 1680966000
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 30"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868246,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-04-15T11:30:00+00:00",
                "timestamp": 1681558200,
                "periods": {
                    "first": 1681558200,
                    "second": 1681561800
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868247,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-04-15T14:00:00+00:00",
                "timestamp": 1681567200,
                "periods": {
                    "first": 1681567200,
                    "second": 1681570800
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868248,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-04-15T14:00:00+00:00",
                "timestamp": 1681567200,
                "periods": {
                    "first": 1681567200,
                    "second": 1681570800
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-2.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868249,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-04-17T19:00:00+00:00",
                "timestamp": 1681758000,
                "periods": {
                    "first": 1681758000,
                    "second": 1681761600
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": false
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 6
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 6
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868250,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-04-15T16:30:00+00:00",
                "timestamp": 1681576200,
                "periods": {
                    "first": 1681576200,
                    "second": 1681579800
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868251,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-04-16T15:30:00+00:00",
                "timestamp": 1681659000,
                "periods": {
                    "first": 1681659000,
                    "second": 1681662600
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-3.api-sports.io/football/teams/65.png",
                    "winner": false
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868252,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-04-15T14:00:00+00:00",
                "timestamp": 1681567200,
                "periods": {
                    "first": 1681567200,
                    "second": 1681570800
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868253,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-04-15T14:15:00+00:00",
                "timestamp": 1681568100,
                "periods": {
                    "first": 1681568100,
                    "second": 1681571700
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": false
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 2,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868254,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-04-16T13:00:00+00:00",
                "timestamp": 1681650000,
                "periods": {
                    "first": 1681650000,
                    "second": 1681653600
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": null
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868255,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-04-15T14:00:00+00:00",
                "timestamp": 1681567200,
                "periods": {
                    "first": 1681567200,
                    "second": 1681570800
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 31"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868256,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-04-23T13:00:00+00:00",
                "timestamp": 1682254800,
                "periods": {
                    "first": 1682254800,
                    "second": 1682258400
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 3
                },
                "fulltime": {
                    "home": 0,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868257,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-04-21T19:00:00+00:00",
                "timestamp": 1682103600,
                "periods": {
                    "first": 1682103600,
                    "second": 1682107200
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": null
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 3,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 3,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868258,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-04-22T14:00:00+00:00",
                "timestamp": 1682172000,
                "periods": {
                    "first": 1682172000,
                    "second": 1682175600
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868259,
                "referee": "S. Hooper",
                "timezone": "UTC",
                "date": "2023-05-24T19:00:00+00:00",
                "timestamp": 1684954800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": null
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868260,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-04-22T14:00:00+00:00",
                "timestamp": 1682172000,
                "periods": {
                    "first": 1682172000,
                    "second": 1682175600
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 0,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868261,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-04-22T11:30:00+00:00",
                "timestamp": 1682163000,
                "periods": {
                    "first": 1682163000,
                    "second": 1682166600
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868262,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-04-22T14:00:00+00:00",
                "timestamp": 1682172000,
                "periods": {
                    "first": 1682172000,
                    "second": 1682175600
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868263,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-04-22T14:00:00+00:00",
                "timestamp": 1682172000,
                "periods": {
                    "first": 1682172000,
                    "second": 1682175600
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868264,
                "referee": "S. Attwell",
                "timezone": "UTC",
                "date": "2023-05-25T19:00:00+00:00",
                "timestamp": 1685041200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": null
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868265,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-04-23T13:00:00+00:00",
                "timestamp": 1682254800,
                "periods": {
                    "first": 1682254800,
                    "second": 1682258400
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 32"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 6,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 5,
                    "away": 0
                },
                "fulltime": {
                    "home": 6,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868266,
                "referee": "Andre Marriner, England",
                "timezone": "UTC",
                "date": "2023-04-27T18:45:00+00:00",
                "timestamp": 1682621100,
                "periods": {
                    "first": 1682621100,
                    "second": 1682624700
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 4
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 4
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868267,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-04-25T19:00:00+00:00",
                "timestamp": 1682449200,
                "periods": {
                    "first": 1682449200,
                    "second": 1682452800
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 1,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868268,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2023-04-26T18:30:00+00:00",
                "timestamp": 1682533800,
                "periods": {
                    "first": 1682533800,
                    "second": 1682537400
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": true
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868269,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-04-27T19:15:00+00:00",
                "timestamp": 1682622900,
                "periods": {
                    "first": 1682622900,
                    "second": 1682626500
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-3.api-sports.io/football/teams/47.png",
                    "winner": null
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868270,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2023-04-26T18:45:00+00:00",
                "timestamp": 1682534700,
                "periods": {
                    "first": 1682534700,
                    "second": 1682538300
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868271,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-04-25T18:30:00+00:00",
                "timestamp": 1682447400,
                "periods": {
                    "first": 1682447400,
                    "second": 1682451000
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868272,
                "referee": "Thomas Bramall, England",
                "timezone": "UTC",
                "date": "2023-04-25T18:45:00+00:00",
                "timestamp": 1682448300,
                "periods": {
                    "first": 1682448300,
                    "second": 1682451900
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-2.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868273,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-04-26T18:45:00+00:00",
                "timestamp": 1682534700,
                "periods": {
                    "first": 1682534700,
                    "second": 1682538300
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868274,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-04-27T18:45:00+00:00",
                "timestamp": 1682621100,
                "periods": {
                    "first": 1682621100,
                    "second": 1682624700
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868275,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-04-26T19:00:00+00:00",
                "timestamp": 1682535600,
                "periods": {
                    "first": 1682535600,
                    "second": 1682539200
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 33"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-3.api-sports.io/football/teams/42.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868276,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2023-04-30T13:00:00+00:00",
                "timestamp": 1682859600,
                "periods": {
                    "first": 1682859600,
                    "second": 1682863200
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-3.api-sports.io/football/teams/35.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 4,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868277,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-05-02T19:00:00+00:00",
                "timestamp": 1683054000,
                "periods": {
                    "first": 1683054000,
                    "second": 1683057600
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": true
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868278,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-04-29T14:00:00+00:00",
                "timestamp": 1682776800,
                "periods": {
                    "first": 1682776800,
                    "second": 1682780400
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868279,
                "referee": "David Coote, England",
                "timezone": "UTC",
                "date": "2023-04-29T14:00:00+00:00",
                "timestamp": 1682776800,
                "periods": {
                    "first": 1682776800,
                    "second": 1682780400
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 6,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 4,
                    "away": 0
                },
                "fulltime": {
                    "home": 6,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868280,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-04-29T11:30:00+00:00",
                "timestamp": 1682767800,
                "periods": {
                    "first": 1682767800,
                    "second": 1682771400
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 2
                },
                "fulltime": {
                    "home": 4,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868281,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-04-30T13:00:00+00:00",
                "timestamp": 1682859600,
                "periods": {
                    "first": 1682859600,
                    "second": 1682863200
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-3.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 2
                },
                "fulltime": {
                    "home": 1,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868282,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-05-01T19:00:00+00:00",
                "timestamp": 1682967600,
                "periods": {
                    "first": 1682967600,
                    "second": 1682971200
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868283,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-04-30T15:30:00+00:00",
                "timestamp": 1682868600,
                "periods": {
                    "first": 1682868600,
                    "second": 1682872200
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 1
                },
                "fulltime": {
                    "home": 4,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868284,
                "referee": "Jarred Gillett, Australia",
                "timezone": "UTC",
                "date": "2023-04-30T13:00:00+00:00",
                "timestamp": 1682859600,
                "periods": {
                    "first": 1682859600,
                    "second": 1682863200
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868285,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-04-30T13:00:00+00:00",
                "timestamp": 1682859600,
                "periods": {
                    "first": 1682859600,
                    "second": 1682863200
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 34"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 3,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 3,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868286,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-05-06T14:00:00+00:00",
                "timestamp": 1683381600,
                "periods": {
                    "first": 1683381600,
                    "second": 1683385200
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 1,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868287,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-05-08T16:30:00+00:00",
                "timestamp": 1683563400,
                "periods": {
                    "first": 1683563400,
                    "second": 1683567000
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": false
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 1,
                "away": 5
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 3
                },
                "fulltime": {
                    "home": 1,
                    "away": 5
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868288,
                "referee": "Robert Jones, England",
                "timezone": "UTC",
                "date": "2023-05-08T14:00:00+00:00",
                "timestamp": 1683554400,
                "periods": {
                    "first": 1683554400,
                    "second": 1683558000
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": true
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-2.api-sports.io/football/teams/46.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 5,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 0
                },
                "fulltime": {
                    "home": 5,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868289,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-05-06T16:30:00+00:00",
                "timestamp": 1683390600,
                "periods": {
                    "first": 1683390600,
                    "second": 1683394200
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-3.api-sports.io/football/teams/40.png",
                    "winner": true
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868290,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-05-06T14:00:00+00:00",
                "timestamp": 1683381600,
                "periods": {
                    "first": 1683381600,
                    "second": 1683385200
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": true
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868291,
                "referee": "Chris Kavanagh, England",
                "timezone": "UTC",
                "date": "2023-05-07T15:30:00+00:00",
                "timestamp": 1683473400,
                "periods": {
                    "first": 1683473400,
                    "second": 1683477000
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-2.api-sports.io/football/teams/34.png",
                    "winner": false
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868292,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-05-08T19:00:00+00:00",
                "timestamp": 1683572400,
                "periods": {
                    "first": 1683572400,
                    "second": 1683576000
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": true
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-2.api-sports.io/football/teams/41.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 4,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 3,
                    "away": 1
                },
                "fulltime": {
                    "home": 4,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868293,
                "referee": "England Darren, England",
                "timezone": "UTC",
                "date": "2023-05-06T14:00:00+00:00",
                "timestamp": 1683381600,
                "periods": {
                    "first": 1683381600,
                    "second": 1683385200
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": true
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-3.api-sports.io/football/teams/52.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868294,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-05-07T18:00:00+00:00",
                "timestamp": 1683482400,
                "periods": {
                    "first": 1683482400,
                    "second": 1683486000
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-2.api-sports.io/football/teams/48.png",
                    "winner": true
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-3.api-sports.io/football/teams/33.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868295,
                "referee": "Stuart Attwell, England",
                "timezone": "UTC",
                "date": "2023-05-06T14:00:00+00:00",
                "timestamp": 1683381600,
                "periods": {
                    "first": 1683381600,
                    "second": 1683385200
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 35"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": true
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-1.api-sports.io/football/teams/66.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 1,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 1,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868296,
                "referee": "Andy Madley, England",
                "timezone": "UTC",
                "date": "2023-05-14T15:30:00+00:00",
                "timestamp": 1684078200,
                "periods": {
                    "first": 1684078200,
                    "second": 1684081800
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": false
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-2.api-sports.io/football/teams/51.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868297,
                "referee": "Peter Bankes, England",
                "timezone": "UTC",
                "date": "2023-05-13T14:00:00+00:00",
                "timestamp": 1683986400,
                "periods": {
                    "first": 1683986400,
                    "second": 1683990000
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": true
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 1
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 1
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868298,
                "referee": "Michael Oliver, England",
                "timezone": "UTC",
                "date": "2023-05-14T13:00:00+00:00",
                "timestamp": 1684069200,
                "periods": {
                    "first": 1684069200,
                    "second": 1684072800
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-2.api-sports.io/football/teams/55.png",
                    "winner": true
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 2,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868299,
                "referee": "Paul Tierney, England",
                "timezone": "UTC",
                "date": "2023-05-13T14:00:00+00:00",
                "timestamp": 1683986400,
                "periods": {
                    "first": 1683986400,
                    "second": 1683990000
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-1.api-sports.io/football/teams/49.png",
                    "winner": null
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-1.api-sports.io/football/teams/65.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868300,
                "referee": "Salisbury Michael, England",
                "timezone": "UTC",
                "date": "2023-05-13T14:00:00+00:00",
                "timestamp": 1683986400,
                "periods": {
                    "first": 1683986400,
                    "second": 1683990000
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": true
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868301,
                "referee": "Anthony Taylor, England",
                "timezone": "UTC",
                "date": "2023-05-14T13:00:00+00:00",
                "timestamp": 1684069200,
                "periods": {
                    "first": 1684069200,
                    "second": 1684072800
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": false
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868302,
                "referee": "Simon Hooper, England",
                "timezone": "UTC",
                "date": "2023-05-13T11:30:00+00:00",
                "timestamp": 1683977400,
                "periods": {
                    "first": 1683977400,
                    "second": 1683981000
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-1.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-3.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": 2,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 1
                },
                "fulltime": {
                    "home": 2,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868303,
                "referee": "Craig Pawson, England",
                "timezone": "UTC",
                "date": "2023-05-15T19:00:00+00:00",
                "timestamp": 1684177200,
                "periods": {
                    "first": 1684177200,
                    "second": 1684180800
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-1.api-sports.io/football/teams/46.png",
                    "winner": false
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-1.api-sports.io/football/teams/40.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 3
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 2
                },
                "fulltime": {
                    "home": 0,
                    "away": 3
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868304,
                "referee": "John Brooks, England",
                "timezone": "UTC",
                "date": "2023-05-13T14:00:00+00:00",
                "timestamp": 1683986400,
                "periods": {
                    "first": 1683986400,
                    "second": 1683990000
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": true
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-2.api-sports.io/football/teams/39.png",
                    "winner": false
                }
            },
            "goals": {
                "home": 2,
                "away": 0
            },
            "score": {
                "halftime": {
                    "home": 1,
                    "away": 0
                },
                "fulltime": {
                    "home": 2,
                    "away": 0
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868305,
                "referee": "Thomas Bramall, England",
                "timezone": "UTC",
                "date": "2023-05-13T14:00:00+00:00",
                "timestamp": 1683986400,
                "periods": {
                    "first": 1683986400,
                    "second": 1683990000
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Match Finished",
                    "short": "FT",
                    "elapsed": 90
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 36"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": false
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-1.api-sports.io/football/teams/36.png",
                    "winner": true
                }
            },
            "goals": {
                "home": 0,
                "away": 2
            },
            "score": {
                "halftime": {
                    "home": 0,
                    "away": 0
                },
                "fulltime": {
                    "home": 0,
                    "away": 2
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868306,
                "referee": "C. Kavanagh",
                "timezone": "UTC",
                "date": "2023-05-20T14:00:00+00:00",
                "timestamp": 1684591200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 504,
                    "name": "Vitality Stadium",
                    "city": "Bournemouth, Dorset"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-2.api-sports.io/football/teams/35.png",
                    "winner": null
                },
                "away": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868307,
                "referee": "P. Tierney",
                "timezone": "UTC",
                "date": "2023-05-21T13:00:00+00:00",
                "timestamp": 1684674000,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 508,
                    "name": "The American Express Community Stadium",
                    "city": "Falmer, East Sussex"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-1.api-sports.io/football/teams/51.png",
                    "winner": null
                },
                "away": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-3.api-sports.io/football/teams/41.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868308,
                "referee": "J. Smith",
                "timezone": "UTC",
                "date": "2023-05-20T14:00:00+00:00",
                "timestamp": 1684591200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 535,
                    "name": "Craven Cottage",
                    "city": "London"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": null
                },
                "away": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-1.api-sports.io/football/teams/52.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868309,
                "referee": "J. Brooks",
                "timezone": "UTC",
                "date": "2023-05-20T14:00:00+00:00",
                "timestamp": 1684591200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 550,
                    "name": "Anfield",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-1.api-sports.io/football/teams/40.png",
                    "winner": null
                },
                "away": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868310,
                "referee": "M. Oliver",
                "timezone": "UTC",
                "date": "2023-05-21T15:00:00+00:00",
                "timestamp": 1684681200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 555,
                    "name": "Etihad Stadium",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-1.api-sports.io/football/teams/50.png",
                    "winner": null
                },
                "away": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868311,
                "referee": "A. Marriner",
                "timezone": "UTC",
                "date": "2023-05-22T19:00:00+00:00",
                "timestamp": 1684782000,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 562,
                    "name": "St. James' Park",
                    "city": "Newcastle upon Tyne"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": null
                },
                "away": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868312,
                "referee": "A. Taylor",
                "timezone": "UTC",
                "date": "2023-05-20T16:30:00+00:00",
                "timestamp": 1684600200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 566,
                    "name": "The City Ground",
                    "city": "Nottingham, Nottinghamshire"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": null
                },
                "away": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-2.api-sports.io/football/teams/42.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868313,
                "referee": "J. Gillett",
                "timezone": "UTC",
                "date": "2023-05-20T11:30:00+00:00",
                "timestamp": 1684582200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 593,
                    "name": "Tottenham Hotspur Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": null
                },
                "away": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868314,
                "referee": "P. Bankes",
                "timezone": "UTC",
                "date": "2023-05-21T12:30:00+00:00",
                "timestamp": 1684672200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 598,
                    "name": "London Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-3.api-sports.io/football/teams/48.png",
                    "winner": null
                },
                "away": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-3.api-sports.io/football/teams/63.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868315,
                "referee": "D. Coote",
                "timezone": "UTC",
                "date": "2023-05-20T14:00:00+00:00",
                "timestamp": 1684591200,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 600,
                    "name": "Molineux Stadium",
                    "city": "Wolverhampton, West Midlands"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 37"
            },
            "teams": {
                "home": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": null
                },
                "away": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-1.api-sports.io/football/teams/45.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868316,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 494,
                    "name": "Emirates Stadium",
                    "city": "London"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 42,
                    "name": "Arsenal",
                    "logo": "https://media-1.api-sports.io/football/teams/42.png",
                    "winner": null
                },
                "away": {
                    "id": 39,
                    "name": "Wolves",
                    "logo": "https://media-1.api-sports.io/football/teams/39.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868317,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 495,
                    "name": "Villa Park",
                    "city": "Birmingham"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 66,
                    "name": "Aston Villa",
                    "logo": "https://media-3.api-sports.io/football/teams/66.png",
                    "winner": null
                },
                "away": {
                    "id": 51,
                    "name": "Brighton",
                    "logo": "https://media-3.api-sports.io/football/teams/51.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868318,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 10503,
                    "name": "Gtech Community Stadium",
                    "city": "Brentford, Middlesex"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 55,
                    "name": "Brentford",
                    "logo": "https://media-3.api-sports.io/football/teams/55.png",
                    "winner": null
                },
                "away": {
                    "id": 50,
                    "name": "Manchester City",
                    "logo": "https://media-2.api-sports.io/football/teams/50.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868319,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 519,
                    "name": "Stamford Bridge",
                    "city": "London"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 49,
                    "name": "Chelsea",
                    "logo": "https://media-2.api-sports.io/football/teams/49.png",
                    "winner": null
                },
                "away": {
                    "id": 34,
                    "name": "Newcastle",
                    "logo": "https://media-1.api-sports.io/football/teams/34.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868320,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 525,
                    "name": "Selhurst Park",
                    "city": "London"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 52,
                    "name": "Crystal Palace",
                    "logo": "https://media-2.api-sports.io/football/teams/52.png",
                    "winner": null
                },
                "away": {
                    "id": 65,
                    "name": "Nottingham Forest",
                    "logo": "https://media-2.api-sports.io/football/teams/65.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868321,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 8560,
                    "name": "Goodison Park",
                    "city": "Liverpool"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 45,
                    "name": "Everton",
                    "logo": "https://media-3.api-sports.io/football/teams/45.png",
                    "winner": null
                },
                "away": {
                    "id": 35,
                    "name": "Bournemouth",
                    "logo": "https://media-1.api-sports.io/football/teams/35.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868322,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 546,
                    "name": "Elland Road",
                    "city": "Leeds, West Yorkshire"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 63,
                    "name": "Leeds",
                    "logo": "https://media-2.api-sports.io/football/teams/63.png",
                    "winner": null
                },
                "away": {
                    "id": 47,
                    "name": "Tottenham",
                    "logo": "https://media-2.api-sports.io/football/teams/47.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868323,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 547,
                    "name": "King Power Stadium",
                    "city": "Leicester, Leicestershire"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 46,
                    "name": "Leicester",
                    "logo": "https://media-3.api-sports.io/football/teams/46.png",
                    "winner": null
                },
                "away": {
                    "id": 48,
                    "name": "West Ham",
                    "logo": "https://media-1.api-sports.io/football/teams/48.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868324,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 556,
                    "name": "Old Trafford",
                    "city": "Manchester"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 33,
                    "name": "Manchester United",
                    "logo": "https://media-1.api-sports.io/football/teams/33.png",
                    "winner": null
                },
                "away": {
                    "id": 36,
                    "name": "Fulham",
                    "logo": "https://media-3.api-sports.io/football/teams/36.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        },
        {
            "fixture": {
                "id": 868325,
                "referee": null,
                "timezone": "UTC",
                "date": "2023-05-28T15:30:00+00:00",
                "timestamp": 1685287800,
                "periods": {
                    "first": null,
                    "second": null
                },
                "venue": {
                    "id": 585,
                    "name": "St. Mary's Stadium",
                    "city": "Southampton, Hampshire"
                },
                "status": {
                    "long": "Not Started",
                    "short": "NS",
                    "elapsed": null
                }
            },
            "league": {
                "id": 39,
                "name": "Premier League",
                "country": "England",
                "logo": "https://media-1.api-sports.io/football/leagues/39.png",
                "flag": "https://media-3.api-sports.io/flags/gb.svg",
                "season": 2022,
                "round": "Regular Season - 38"
            },
            "teams": {
                "home": {
                    "id": 41,
                    "name": "Southampton",
                    "logo": "https://media-1.api-sports.io/football/teams/41.png",
                    "winner": null
                },
                "away": {
                    "id": 40,
                    "name": "Liverpool",
                    "logo": "https://media-2.api-sports.io/football/teams/40.png",
                    "winner": null
                }
            },
            "goals": {
                "home": null,
                "away": null
            },
            "score": {
                "halftime": {
                    "home": null,
                    "away": null
                },
                "fulltime": {
                    "home": null,
                    "away": null
                },
                "extratime": {
                    "home": null,
                    "away": null
                },
                "penalty": {
                    "home": null,
                    "away": null
                }
            }
        }
    ]
}